import ReactModal from "react-modal";
import { Info } from "lucide-react";
import { Close } from "@/components/common/svgs";
import { PredictionMarketsMap } from "@/components/dataPages/prediction/marketPotential/PredictionMarketsMap";

export const SelectOnMapModal = ({
    isOpen,
    onClose,
    title,
    outbounds,
    filterOutbounds,
    pickupMarkets,
    excludedPickupMarkets,
    onTogglePickupMarket,
    marketLoads,
}) => {

    return (
        <ReactModal
            isOpen={isOpen}
            onRequestClose={onClose}
            shouldCloseOnOverlayClick={false}
            ariaHideApp={false}
            overlayClassName="ReactModal__Overlay fixed inset-0 bg-black/70 z-modal flex items-center justify-center"
            className="fixed inset-0 flex items-center justify-center pointer-events-none"
        >
            <div className="bg-cm-p-background rounded-[12px] max-w-[804px] w-full flex flex-col m-4 h-[100%] max-h-[571px] pointer-events-auto">
                <div className="flex justify-between items-center px-6 py-5 border-b border-cm-p-outline-variation shrink-0">
                    <h2 className="text-[18px] leading-[28px] font-medium text-cm-p-text-primary">
                        {title}
                    </h2>
                    <button
                        type="button"
                        onClick={onClose}
                        className="p-1 rounded hover:bg-cm-p-surface-hover"
                        aria-label="Close"
                    >
                        <Close />
                    </button>
                </div>
                <div className="overflow-hidden relative h-[464px] shrink-0">
                    <PredictionMarketsMap
                        outbounds={outbounds}
                        optimizePer={{ id: "rpm" }}
                        filterOutbounds={filterOutbounds}
                        pickupMarkets={pickupMarkets}
                        excludedPickupMarkets={excludedPickupMarkets}
                        onTogglePickupMarket={onTogglePickupMarket}
                        marketLoads={marketLoads}
                        themes={["loadboard", "hideControls"]}
                    />
                </div>
                <div className="flex items-start gap-2 px-6 py-4 border-t border-cm-p-outline-variation bg-cm-p-surface shrink-0">
                    <Info className="size-4 text-cm-p-text-secondary shrink-0" />
                    <p className="text-xs text-cm-p-text-secondary">
                        We'll look for delivery locations in your selected markets, within the radius you chose.
                    </p>
                </div>
            </div>
        </ReactModal>
    );
};
